module.exports = __webpack_public_path__ + "img/Stumpf.577fc810.svg";